import SubPageMenu from "../../../../common/SubPageMenu";
import { configurationSubPages } from "./ConfigurationPage";

const ConfigurationMenu = (props) => {
  return <SubPageMenu 
    subPages={configurationSubPages} 
    menuId="configurationMenu"
    ariaLabel="configuration tabs example"
    {...props} 
  />
}

export default ConfigurationMenu;

